import { useTranslation } from '@mc/i18n'
import { Button, IconShareDefault, IconInfoDefault } from '@mc/design-system'
import { paths } from '@mc/paths'

import { getIsSeries } from 'libs/utils'

import { TCourse } from '../../CategoryPage/dataFetching'
import { trackShareButtonClick, trackViewClassInfoClick } from './events'

export const ViewClassShareButtonGroup = ({
  content: { type, slug, uuid },
  onShareClickHandler,
  trackProps,
}: {
  content: TCourse
  onShareClickHandler: () => void
  trackProps: {
    categorySlug: string
  }
}) => {
  const { t } = useTranslation('@mc/next')
  const isSeries = getIsSeries(type)

  const onShareClick = () => {
    trackShareButtonClick({
      classSlug: slug,
      uuid,
      categorySlug: trackProps.categorySlug,
    })
    onShareClickHandler()
  }

  const onViewClassInfoClick = () =>
    trackViewClassInfoClick({
      classSlug: slug,
      link: paths.courseTypePage(type, slug),
      uuid,
      ...trackProps,
    })

  return (
    <>
      <Button kind='link' onClick={onShareClick} data-testid='share-btn'>
        <IconShareDefault
          srText={t(
            isSeries ? 'categories.a11y.shareSeries' : 'categories.a11y.share',
          )}
        />
      </Button>

      <Button
        kind='secondary'
        as='a'
        href={paths.courseTypePage(type, slug)}
        onClick={onViewClassInfoClick}
      >
        <IconInfoDefault className='mc-mr-3' />
        {t(isSeries ? 'categories.cta.series' : 'categories.cta.class')}
      </Button>
    </>
  )
}
